export const TOGGLE_PARTICIPANT_RIGHT = 'TOGGLE_PARTICIPANT_RIGHT';